export const body = {
  bg: 'white',
};

export const colors = {
  //teal
  pastelTeal: '#D8F6F8',
  brightTeal: '#20C8DA',
  mrmMedTeal: '#009FB5',
  mrmMedDarkTeal: '#0A92A5',
  mrmTeal: '#006873',
  darkTeal: '#0F363B',
  darkGreyishTeal: '#244147',
  darkestTeal: '#0B252B',

  //grey
  extraLightCoolGrey: '#EAEEEF',
  lightTealGrey: '#BFC9CB',
  tealGrey: '#98A1A1',
  medTealGrey: '#4E5457',
  darkTealGrey: '#363D41',
  darkestTealGrey: '#21292D',
  tealBlack: '#141818',
  hybleGrey: '#F0F5F6',

  //charcoal
  lightestGrey: '#E8E8E8',
  lightCharcoalGrey: '#C3C5C9',
  charcoalGrey: '#84878B',
  medCharcoalGrey: '#686A6D',
  medDarkCharcoalGrey: '#55585B',
  darkCharcoalGrey: '#414547',
  darkestCharcoalGrey: '#282D2E',
  charcoalBlack: '#232627',

  //red
  pinkSpritz: '#FFE1E5',
  hotPink: '#F55366',
  cosmoRedLight: '#FF535D',
  cosmoRed: '#E73D47',

  //green
  mojitoMint: '#D6F4E8',
  absynthGreen: '#4ACB85',
  darkAbsynthGreen: '#325C48',

  //orange
  peachSchnapps: '#FFF1EC',
  icedOrangeSpritz: '#FFC9B8',
  orangeSpritz: '#FC815A',
  amber: '#3E3623',
  mustard: '#FFD171',

  //blue
  curacaoSky: '#E6F1FF',
  skyBlue: '#29A1FF',
  curacaoBlue: '#0E88E4',

  //purple
  darkIndigo: '#452995',
  medIndigo: '#5A37BE',
  brightIndigo: '#6C44DC',
  lightIndigo: '#B59CFF',
  pastelIndigo: '#DFD4FF',

  //white
  white: '#F6F7F9',

  //messaging
  warning: '#FFBA53',
  warningDark: 'rgba(62, 54, 35, 1)',
  information: 'rgba(0, 159, 181, 0.4)',
  error: 'rgba(231, 61, 71, 0.4)',
  success: 'rgba(24, 66, 51, 1)',
};
